/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
// import assetify from "@quintype/framework/assetify";
// import PaywallImage from "../../../../../assets/images/nl-hill-sub.png";
// import logo from "../../../../../assets/images/newslaundry_logo.png";
import "./paywall.m.css";
import { getAuthUrl } from "../../../helper/hooks";
import { SubscriptionPlanGrid } from "../subscription-plan-grid";
import {
  PEOPLE_CARRYING_NL_CLIP_UPHILL,
  COMPRESS_PARAMS_MEDIUM
} from "../../../../image-constants.js";
// import Axios from "axios";

export const Paywall = props => {
  const state = useSelector(state => state);
  // const [hindiPlan, SetHindiPlan] = useState("3 months subscription");
  // const [isIndian, setIsIndian] = useState(true);
  // const [completedAmount, setCompletedAmount] = useState(9);
  // const [targetAmount, setTargetAmount] = useState(800);
  // const barWidth = (completedAmount / targetAmount) * 100;
  const [isHindi, setIsHindi] = React.useState(false);

  // const IS_HINDI = !!(
  //   global.location && global.location.host.includes("hindi")
  // );

  const userCountry = useSelector(state =>
    get(state, ["fetchUserCountry"], {
      country_code: "",
      country_code_alias: "",
      country_name: "",
      user_timezone: ""
    })
  );

  const fetchSubscription = useSelector(state => state.fetchSubscription);

  const member = useSelector(state => {
    return get(state, ["member"], null);
  });
  // const authUrl = getAuthUrl();

  const pushToDataLayer = (event, url, action) => {
    const obj = {
      event: event,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    if (url) {
      obj.paywall_content_name = url;
    }

    if (action) {
      obj.paywall_user_action = action;
    }

    window.dataLayer.push(obj);
  };

  useEffect(() => {
    pushToDataLayer("story_paywall", props.url, null);
  }, []);

  // useEffect(() => {
  //   Axios.get("https://server.newslaundry.com/hindiSubscribersCount/")
  //     .then(response => {
  //       setCompletedAmount(response.data.userCount);
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       setCompletedAmount(9);
  //     });
  // }, []);

  useEffect(() => {
    setIsHindi(global.location.host.includes("hindi."));
  }, [state]);

  const authUrl = getAuthUrl();
  const storyReturnUrl = props.url
    ? `/${String(props.url).replace(/^\/+/, "")}`
    : "";

  if (isHindi) {
    return (
      <div styleName="current-hindi-wrapper">
        <div styleName="current-hindi-paywall">
          <div styleName="current-hindi-content">
            <div styleName="current-hindi-copy">
              <h1>स्वतंत्र पत्रकारिता यानि नागरिकों की आजादी की गारंटी</h1>
              <p>
                एक-दो बातें आपसे कहनी हैं. न्यूज़लॉन्ड्री की ये खबर आप तक
                पहुंचाने के पीछे हमारा मकसद एक सजग, जागरुक नागरिक तैयार करना है.
                इसका आधार स्वतंत्र और निष्पक्ष पत्रकारिता है, न्यूज़लॉन्ड्री
                हिंदी ने एक अलग रास्ता चुना है. सब्सक्रिप्शन का रास्ता. हमारी
                सात सदस्यों की टीम को आपके समर्थन की जरूरत है.{" "}
              </p>
              <p styleName="more-text">
                हिंदी टीम को आपका इंतजार है. क्या आप यह लक्ष्य पूरा करेंगे?{" "}
              </p>
            </div>

            <SubscriptionPlanGrid
              member={member}
              intent="self_subscription"
              isHindi={true}
              userCountry={userCountry}
              returnUrl={storyReturnUrl}
              onSubscribe={() =>
                pushToDataLayer(
                  "story_paywall_user_action",
                  props.url,
                  "subscribe"
                )
              }
            />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div styleName="cta">
          <h2 styleName="paywall-title">Subscribe now to unlock the story</h2>
          <br />
        </div>
        <div styleName="english-paywall-wrapper">
          <div styleName="english-paywall-intro">
            <img
              src={`${PEOPLE_CARRYING_NL_CLIP_UPHILL}${COMPRESS_PARAMS_MEDIUM}`}
              alt="paywall image"
            />
            <div styleName="english-paywall-copy">
              <h2 styleName="title">Why should I pay for news?</h2>
              <p styleName="description">
                Independent journalism is not possible until you pitch in. We
                have seen what happens in ad-funded models: Journalism takes a
                backseat and gets sacrificed at the altar of clicks and TRPs.
                <br />
                <br />
                Stories like these cost perseverance, time, and resources.
                Subscribe now to power our journalism.
              </p>
            </div>
          </div>

          <SubscriptionPlanGrid
            member={member}
            intent="self_subscription"
            isHindi={false}
            userCountry={userCountry}
            returnUrl={storyReturnUrl}
            onSubscribe={() =>
              pushToDataLayer(
                "story_paywall_user_action",
                props.url,
                "subscribe"
              )
            }
          />

          {!member && (
            <p styleName="english-login">
              Already a subscriber?{" "}
              <a
                onClick={() => {
                  pushToDataLayer(
                    "story_paywall_user_action",
                    props.url,
                    "login"
                  );
                  window.location = authUrl;
                }}
              >
                Login
              </a>
            </p>
          )}
        </div>
      </>
    );
  }
};
